/* eslint-disable no-use-before-define */
/* eslint-disable camelcase */
// import { AxiosResponse } from 'axios';
// import { Message as $message } from 'element-ui';
// import $t from '@/modules/FPKG-20000-Util/lang';
import errorCode from '../../errorCode'; // 進行後端error code提示
import router from '@/modules/FPKG-20000-Util/vueRouter'; // lists 使用的router
import $http from '@/modules/FPKG-20000-Util/prototypes/axios'; // 後端溝通
import $store from '@/modules/FPKG-50000-Vuex/index'; // lists 與axios溝通
import TimeFormater from '@/modules/FPKG-20000-Util/converter/timeFormater';


// validate
class Lists {
  private request: any;

  constructor(request?: Object) {
    this.request = request;
  }

  public async get(): Promise<Object> {
    const { currentRoute } = router;
    /** 取得搜尋參數: 從 query, params, user設定 進行整理 */
    const params = {
      ...currentRoute.query, ...currentRoute.params, ...this.request,
    };
    const d = await $http.get('transaction/apply/lists', { params });
    if (d.data.code === 0) {
      const result = d.data.response;
      $store.dispatch('getList', result);
      if (result.list !== null && result.list.length) {
        result.list = result.list.map(formater);
      }
      return result;
    }
    try {
      throw errorCode(d.data);
    } catch (error) {
      return {};
    }
  }
}


export default Lists;


/** 將返回的檔案進行轉換 */
const formater = (item: object) => {
  const result: any = item;
  const formatedDate = new TimeFormater({ value: result.p9_ton_created_at });
  result.p9_ton_created_at = formatedDate.result;
  return result;
};
